import { render } from "./Interconsulta_PlanDiag.vue?vue&type=template&id=5fa2b173"
import script from "./Interconsulta_PlanDiag.vue?vue&type=script&lang=js"
export * from "./Interconsulta_PlanDiag.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__